import * as yup from 'yup'
import { EMAIL_REGEX } from '../strings/yup-regex'

export const addMemberSchema = yup.object().shape({
  name: yup.string().required('Full name is a required'),
  email: yup.string().matches(EMAIL_REGEX, 'Invalid email address').required('Email is a required field'),
})